export const trimComment = (comment: string, maxLength = 100): string => {
  if (comment.length < maxLength) {
    return comment;
  }
  return comment.substring(0, maxLength - 3) + "...";
};
